export const getAssetPath = (path: string, poster?: boolean): string => {
  if(typeof path === "string"){
    if(path.includes('vimeo')) return path;
    const str = process.env.NODE_ENV === "development" ? path?.replace("-/", "https://aurecongroup.com/-/") : path;
    return str?.replace("/http", "http") + (poster ? '' : '?as=0&w=2048');
  } else {
    console.info("Parameter - path - provided is not a valid string value!");
    return "";
  }
}

export const getAssetPathByHeight = (path: string, h: number): string => {
  if(typeof path === "string"){
    const str = process.env.NODE_ENV === "development" ? path?.replace("-/", "https://aurecongroup.com/-/") : path;
    console.log(str?.replace("/http", "http") + `?as=0&h=${h}`)
    return str?.replace("/http", "http") + `?as=0&h=${h}`;
  } else {
    console.info("Parameter - path - provided is not a valid string value!");
    return "";
  }
}

//  Determine appropriate width for smaller image blocks.
/**
 * path: path of resournce.
 * width: % of screen to fill.
 * x: scale up image, default: x 1
*/
export const getAssetPathAndSize = (path: string, width: number, x = 1) => {
  if(typeof path === "string"){
    const str = process.env.NODE_ENV === "development" ? path?.replace("-/", "https://aurecongroup.com/-/") : path;
    const w = window.innerWidth / 100 * width;
    return str?.replace("/http", "http") + `?as=0&w=${Math.floor(Math.floor(w) * x)}`;
  } else {
    console.info("Parameter - path - provided is not a valid string value!");
    return "";
  }
};

